<template>
  <div class="map">
    <div class="poidiv">
      <div class="search">
        <el-input placeholder="请输入关键字检索地图" prefix-icon="el-icon-search" v-model.trim="searchValue">
          <el-button slot="append" class="input-select-btn" @click="search">搜 索</el-button>
        </el-input>
      </div>
      <div class="poilist" v-if="pois.length">
        <div v-for="(poi,index) in pois" :key="index" style="border-top: 1px solid #d0d0d0;margin-left: 5px"
             @click="poiclick(index,poi.location);">
          <div v-bind:style="{'color':isclick==index?'#25A5F7':'#606266'}">{{ poi.name }}</div>
          <div v-bind:style="{'color':isclick==index?'#25A5F7':'#606266'}">
            {{ poi.pname + poi.cityname + poi.adname + poi.address }}
          </div>
        </div>
      </div>
    </div>
    <div class="mapdiv">
      <div id="container"></div>
    </div>
  </div>
</template>
<script>

export default {
  mounted() {
    this.initMap();
  },
  data() {
    return {
      clickListener: null,
      map: null,
      markers: [],
      searchValue: "",
      country: "",
      province: "",
      city: "",
      district: "",
      township: "",
      formatted_address: "",
      pois: [],
      isclick: null,
      position: {
        lng: '',
        lat: ''
      },
      street: ""
    }
  },
  methods: {
    sendMsg() {
      let pcd = this.province;
      if (Array.isArray(this.city)) {
        if (!this.city.length) {
          this.city = '市辖区';
        } else {
          this.city = this.city[0];
        }
      } else if (this.city) {
        pcd += this.city;
      }
      if (Array.isArray(this.district)) {
        if (!this.district.length) {
          this.district = '市辖区';
        } else {
          this.district = this.district[0];
        }
      } else if (this.district) {
        pcd += this.district;
      }
      let _address = {
        province: this.province,
        city: this.city,
        district: this.district,
        street: this.street,
        address: this.formatted_address.replace(pcd, ''),
        formatted_address: this.formatted_address,
      };
      this.$emit('receiveAddress', _address, this.position)
    },
    initMap: function () {
      this.clickListener, this.map = new AMap.Map('container', {
        resizeEnable: true,
        keyboardEnable: false
      });
      //定位
      this.map.plugin('AMap.Geolocation', () => {
        var geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,//是否使用高精度定位，默认:true
          timeout: 10000,          //超过10秒后停止定位，默认：5s
          buttonPosition: 'RB',    //定位按钮的停靠位置
          buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
        });
        this.map.addControl(geolocation);
        geolocation.getCurrentPosition((status, result) => {
          if (status == 'complete') {
            this.position.lng = result.position.lng;
            this.position.lat = result.position.lat;
            this.getAddress(result.position);
          } else {
            console.log("定位失败,失败原因排查信息" + result.message)
          }
        });
      });
      //地图点击事件
      this.clickListener = this.map.on("click", (e) => {
        var that = this;
        this.getAddress(e.lnglat).then(function () {
          that.cleanMarks();
          that.pois = [];
          that.searchValue = "";
          that.addMarks(e.lnglat)
          that.sendMsg();
        })
      });
    },
    //搜索地图信息
    search() {
      var keywords = this.searchValue;
      this.isclick = null;
      this.$jsonp("//restapi.amap.com/v3/place/text?key=264e55a30128eb0ffa4ecef0c41374eb&keywords=" + keywords + "&types=&city=" + this.city + "&children=&offset=&page=&extensions=all",
      ).then((json) => {
        if (json.status == 1) {
          this.pois = json.pois;
          // for (var i = 0; i < json.pois.length; i++) {
          //     poi = json.pois[i];
          //     this.formatted_address = poi.pname+poi.cityname+poi.adname+poi.address+poi.name;
          //     this.province = poi.pname;
          //     this.city = poi.cityname;
          //     this.district =poi.adname;
          //     this.township = poi.address;
          //     this.addMarks(poi.location);
          // }

        }
      });
    },
    //添加mark
    addMarks(position) {
      if (position instanceof Array) {
        this.position.lng = position[0];
        this.position.lat = position[1];
      } else {
        this.position.lng = position.lng;
        this.position.lat = position.lat;
      }
      var markerSpan = document.createElement("span");
      var markerContent = document.createElement("div");
      markerSpan.className = 'marker';
      markerSpan.innerHTML = this.formatted_address;
      // 点标记中的图标
      var markerImg = document.createElement("img");
      markerImg.width = 27;
      markerImg.height = 40;
      markerImg.src = require("../assets/poi-marker-red.png");

      markerContent.appendChild(markerImg);
      markerContent.appendChild(markerSpan);
      this.markers[0] = new AMap.Marker({
        position: position,
        map: this.map,
        content: markerContent
      });
      this.map.setFitView();
    },
    //清空mark
    cleanMarks() {
      if (this.markers.length > 0) {
        for (let i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
          this.markers[i] = null;
        }
        this.markers.length = 0;
      }
    },
    //获取省市区信息
    getAddress(position) {
      return new Promise((resolve, reject) => {
        this.$jsonp("//restapi.amap.com/v3/geocode/regeo?key=264e55a30128eb0ffa4ecef0c41374eb&location=" + position + "",
        ).then((json) => {
          if (json.status == 1) {
            this.country = json.regeocode.addressComponent.country;
            this.province = json.regeocode.addressComponent.province;
            this.city = json.regeocode.addressComponent.city;
            this.district = json.regeocode.addressComponent.district;
            this.township = json.regeocode.addressComponent.township.length == 0 ? '' : json.regeocode.addressComponent.township;
            this.formatted_address = json.regeocode.formatted_address;
            resolve();
          }
        });
      })
    },
    poiclick(index, position) {
      this.isclick = index;
      this.cleanMarks();
      this.getAddress(new Array(position.split(',')[0], position.split(',')[1])).then(() => {
        this.cleanMarks();
        this.addMarks(new Array(position.split(',')[0], position.split(',')[1]))
        this.sendMsg();
      });
      this.pois = [];
    },
    clearData() {
      this.searchValue = '';
      this.pois = [];
      this.initMap()
    }
  }
}
</script>
<style scoped lang="scss">
.map {
  display: flex;
  flex-direction: column;
  position: relative;

  .poidiv {
    flex: 1;
    position: absolute;
    z-index: 1;
    margin: 10px;

    .search {
      margin-bottom: 10px;
    }

    .poilist {
      height: 325px;
      overflow-y: scroll;
      background-color: white;
    }
  }

  .mapdiv {

    #container {
      width: 100%;
      height: 400px;
      margin-bottom: 20px;
    }

    .street {
      display: inline-block;

      .el-input {
        width: 260px;
      }
    }
  }

  /deep/ .el-dialog__body {
    padding: 10px 20px;
  }
}

</style>
